import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { CreateOrderFromConversationButton } from './CreateOrderFromConversation/CreateOrderFromConversationButton'
import { OrderCodeLink } from './OrderCodeLink/OrderCodeLink'
import { OrderSelect } from './Select'
import { OrderWidget } from './Widget'

export const orderContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.order.orderCodeLink).to(OrderCodeLink)
  bind(WebuiIocKey.order.orderSelect).to(OrderSelect)
  bind(WebuiIocKey.order.orderWidget).to(OrderWidget)
  bind(WebuiIocKey.order.createOrderFromConversationButton).to(CreateOrderFromConversationButton)
})
